
import LoginImage from "../Images/loginpage.gif";

export const Admin =[
    {
        id : 1,
        path : LoginImage,
    },
]